import { useCallback, useEffect, useState } from "react";
import styled from 'styled-components';
import { notification } from 'antd';
import { Doughnut } from "react-chartjs-2";
import {
	Chart as ChartJS,
	ArcElement,
	Legend,
	Tooltip,
	Title
} from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';

// services
import * as UniverseService from '../../../../services/bb-api/universe';

ChartJS.register(
	ArcElement,
	Legend,
	Tooltip,
	Title
);

export const GenderDiagram: React.FC = () => {
	const [userData, setUserData] = useState<{ gender: string, memberCount: number }[]>([]);

	const getData = useCallback(() => {
		try {
			UniverseService.getGenderDistribution(13).then(setUserData)
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [])

	useEffect(() => {
		getData();
		const intervalTime = 60 * 1000 // 1 min
		const intervalId = setInterval(getData, intervalTime)
		return () => clearInterval(intervalId)
	}, [getData]);

	function getMemberCount(): Array<number> {
		const order = ['Female', 'Male', 'Other', 'Unknown']
		const memberCount = order.map(gender => {
			const item = userData.find(item => item.gender === gender)
			return item?.memberCount || 0
		})
		return memberCount
	}

	const chartData = {
		labels: ['Kvinder', 'Mænd', 'Andet', 'Ukendt'],
		datasets: [
			{
				data: getMemberCount(),
				backgroundColor: [
					'#ffb9dc',
					'#96cbe4',
					'#e2d799',
					'#e0e0e0',
				],
				borderColor: '#1f2937',
				borderWidth: 2,
				borderRadius: 6,
			},
		],
	};

	const chartOptions: Record<string, any> = {
		plugins: {
			title: {
				display: true,
				text: 'Køn',
				color: 'rgba(255, 255, 255, 0.55)',
				font: {
					size: 16,
				},
			},
			legend: {
				position: 'right',
				labels: {
					usePointStyle: true,
					padding: 20,
					color: 'rgba(255, 255, 255, 0.55)',
				},
			},
			datalabels: {
				display: 'auto',
				color: 'rgba(255, 255, 255, 0.55)',
				anchor: 'end',
				align: 'end',
				formatter: (value: number, context: any) => {
					const dataset = context.chart.data.datasets[context.datasetIndex];
					const total = dataset.data.reduce((acc: number, data: number) => acc + data, 0);
					const percentage = ((value / total) * 100).toFixed(1);
					return `${percentage}%`;
				},
			}
		},
		aspectRatio: 2,
	};

	return (
		<StyledContainer className="gender-diagram">
			<div className="diagram">
				<Doughnut
					data={chartData}
					options={chartOptions}
					plugins={[ChartDataLabels]} // ignore this error - it works
				/>
			</div>
		</StyledContainer>
	);
}

const StyledContainer = styled.div`
	margin: 1em;

	.diagram {
		width: 100%;
		height: 100%;
		box-shadow: rgba(0,0,0,0.2) 0px 2px 8px 0px;
		background-color: #1f2937;
		border-radius: 0.5em;
		padding: 1em 2em;
	}
`
